import React from 'react';
import FeatureCards from "../../../../components/FeatureCards/FeatureCards";
import CTA from "../../../../components/Constant/cta/CTA";
import TimelineSection from "../../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../../components/WhySection/WhySection";
import LocationTimeline from "../../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../../components/IntroSection/IntroSection";
import FAQList from "../../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../../components/ServiceCards/ServiceCards";

export default function TrustInsuranceLicensesMwali() {

    return (
        <main className='main'>

            <IntroSection
                title="Trust & Insurance License – Mwali (Comoros)"
                subtitle="Build Fiduciary & Insurance Businesses with MISA Licensing"
                description="<b>Mwali (Mohéli, Comoros)</b>, under the <b>Mwali International Services Authority (MISA)</b>, offers <b>internationally recognized Trust and Insurance Licenses</b>. These licenses are ideal for firms looking to operate in <b>fiduciary services</b>, <b>asset protection</b>, <b>captive insurance</b>, and <b>reinsurance</b>, with a balance of <b>global credibility</b>, <b>moderate requirements</b>, and <b>affordable costs</b>."
                badges={
                    [
                        "Trust & Fiduciary Licenses",
                        "Captive & General Insurance Licenses",
                        "Reinsurance"
                    ]
                }
                buttonText=""
                buttonLink="/quote"
                imageSrc={require("../../../../assets/images/services/trust-insurance-licenses-mwali-hero.jpg")}
                imageAlt=""
            />

            <section className='section'>
                <div className="container">

                    <WhySection
                        title='Why Choose Mwali?'
                        blocks={
                            [
                                {
                                    items:
                                        [
                                            {
                                                title: "Global Recognition",
                                                text: "Trusted by clients, investors, and PSPs worldwide."
                                            },
                                            {
                                                title: "MISA-Regulated",
                                                text: "Compliance-based, FATF-aligned authority."
                                            },
                                            {
                                                title: "Comprehensive Options",
                                                text: "Trust, insurance, and reinsurance structures."
                                            },
                                            {
                                                title: "Better Banking & PSP Access",
                                                text: "Better than newer regulators (Western Sahara, Anjouan)."
                                            },
                                            {
                                                title: "Faster & Cheaper",
                                                text: "Faster & cheaper than EU regulators (Malta, Bermuda, Isle of Man)."
                                            }
                                        ]
                                }
                            ]
                        }
                    />

                    <InfoBlocks
                        title="What the Licenses Cover"

                        blocks={
                            [
                                {
                                    title: "Trust & Fiduciary License",
                                    subtitle: "Operate as a regulated fiduciary under MISA:",
                                    items:
                                        [
                                            {
                                                text: "Trustee & fiduciary services"
                                            },
                                            {
                                                text: "Family office & wealth management structures"
                                            },
                                            {
                                                text: "Asset protection trusts"
                                            },
                                            {
                                                text: "Succession & estate planning"
                                            },
                                            {
                                                text: "Corporate fiduciary & nominee services"
                                            }
                                        ]
                                },
                                {
                                    title: "Insurance & Reinsurance License",
                                    subtitle: "Offer insurance solutions with global flexibility:",
                                    items:
                                        [
                                            {
                                                text: "General insurance (life, health, property, casualty)"
                                            },
                                            {
                                                text: "Captive insurance (corporate self-insurance)"
                                            },
                                            {
                                                text: "Reinsurance services (international reach)"
                                            },
                                            {
                                                text: "Niche coverage (fintech, crypto, high-risk industries)"
                                            }
                                        ]
                                }
                            ]
                        }
                    />

                    <LocationTimeline
                        title="Capital Requirements"
                        item={
                            [
                                {
                                    title: "Moderate Capital Requirement",
                                    text: "Compared to EU/Tier-1 regulators."
                                },
                                {
                                    title: "Typical Range",
                                    text: "USD 100,000–250,000+, depending on license type."
                                },
                                {
                                    title: "Final Capital",
                                    text: "Obligations set by MISA during application review."
                                }
                            ]
                        }
                    />

                    <ServiceCards
                        title='Benefits of a Mwali Trust & Insurance License'
                        services={
                            [
                                {
                                    title: "Credibility",
                                    text: "More trusted than emerging regulators."
                                },
                                {
                                    title: "Investor & Client Confidence",
                                    text: "Regulated by a respected authority."
                                },
                                {
                                    title: "Compliance-Based",
                                    text: "AML/KYC aligned with FATF standards."
                                },
                                {
                                    title: "Flexibility",
                                    text: "Operate trust + insurance within one structure."
                                },
                                {
                                    title: "Affordable & Fast",
                                    text: "2–3 weeks setup, lower fees than EU regulators."
                                }
                            ]
                        }
                    />

                    <FeatureCards
                        title='Licensing Process'
                        features={[
                            {
                                title: "Consultation & Structuring",
                                text: "Select trust, insurance, or combined model."
                            },
                            {
                                title: "Company Incorporation",
                                text: "Register IBC under Mwali jurisdiction."
                            },
                            {
                                title: "Compliance Documentation",
                                text: "AML/KYC manuals, risk frameworks, business plan."
                            },
                            {
                                title: "Application Filing",
                                text: "Offshore Advisory submits to MISA."
                            },
                            {
                                title: "Approval & License Grant",
                                text: "Typically within 2–3 weeks."
                            }
                        ]
                        }
                    />

                    <TimelineSection
                        title='Timeline & Costs'
                        items={
                            [
                                {
                                    name: "Timeline",
                                    duration: "2–3 weeks.",
                                },
                                {
                                    name: "Setup Costs",
                                    description: "from USD 20,000+."
                                },
                                {
                                    name: "Capital Requirement",
                                    description: "USD 100k–250k+ (scope dependent)."
                                },
                                {
                                    name: "Renewals",
                                    description: "annual fees payable to MISA."
                                },

                            ]
                        }
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                {
                                    text: "Recognized MISA agent with trust & insurance licensing expertise."
                                },
                                {
                                    text: "End-to-end services: incorporation, compliance, licensing, PSP access."
                                },
                                {
                                    text: "Access to captive insurance consultants, fiduciary networks, and fund administrators."
                                },
                                {
                                    text: "Flexible structuring for HNWI family offices & corporate risk management."
                                }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />
                    <CTA
                        title="Looking to launch a fiduciary or insurance business?"
                        description="Mwali (Comoros) offers globally recognized trust and insurance licenses under MISA with affordable costs and moderate requirements."
                        buttonText="Book a Mwali Trust & Insurance Consultation →"
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "How recognized are Mwali trust and insurance licenses?",
        content: [
            { type: "answer", text: "They are globally respected, carrying stronger credibility than newer offshore regulators." },
        ],
    },
    {
        question: "What is the capital requirement?",
        content: [
            { type: "answer", text: "Moderate — usually USD 100k–250k+, depending on license type and structure." },
        ],
    },
    {
        question: "Can I combine trust and insurance in one company?",
        content: [
            { type: "answer", text: "Yes — MISA allows combined licensing for multi-service providers." },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "2–3 weeks, depending on documentation." },
        ],
    },
    {
        question: "Can I launch a captive insurance company under this license?",
        content: [
            { type: "answer", text: "Yes — Mwali supports both captive insurance and reinsurance structures." },
        ],
    },
];


const testimonialsData =
    [
        {
            quote: "Offshore Advisory guided us through a Mwali fiduciary license setup. Excellent for asset protection and wealth management.",
            author: "Elena D.",
            role: "Fiduciary Director"
        },
        {
            quote: "We structured a captive insurance license in Mwali. Offshore Advisory handled incorporation, licensing, and compliance seamlessly.",
            author: "Michael P.",
            role: "CFO"
        }
    ]
;
